import classnames from "classnames";
import { inject, observer } from "mobx-react";
import type { Store } from "@inferno/renderer-shared-core";
import { ResponsiveImage } from "../../components/ResponsiveImage.component";
import * as Webapi from "@ihr-radioedit/inferno-webapi";
import { getLayout } from "../../lib/content";
import { canHaveOps, getResponsiveValues } from "@inferno/renderer-shared-core";
import "../../components/tiles/ContentTile.style.scss";
import styles from "./AudienceDatasource.module.scss";

interface AudienceFeedItemProps {
  item: Webapi.AudienceRecordFragment;
  style: string;
  store?: Store;
  callback?: (args?: any) => void;
}

export const AudienceFeedItem = inject("store")(
  observer(({ item, style, store, callback }: AudienceFeedItemProps) => {
    if (!store) {
      return null;
    }

    if (!item.terms) {
      return null;
    }

    const layout = getLayout(style);
    const tileClass = classnames(["feed-content-item", "component-content-tile", `${styles.audienceItem}`, layout], {
      external: !canHaveOps(item.grid_image),
    });

    const responsive = getResponsiveValues(item.grid_image, layout);

    return (
      <figure className={tileClass} onClick={() => callback?.(item.terms)}>
        <div className="thumb-container">
          <ResponsiveImage
            alt={item.title}
            src={item.grid_image}
            srcset={responsive.srcset}
            sizes={responsive.sizes}
            placeholderSrcset={responsive.placeholderSrcset}
          />
        </div>
        <figcaption>
          <span className="card-title">{item.title}</span>
        </figcaption>
      </figure>
    );
  }),
);

export default AudienceFeedItem;
